// src/pages/seo/SeoMaintenance.tsx

import React from 'react';
import { withAdminGate } from '@/guards/adminGate';
import { useSeoBundle, useSaveSeo, useAISuggest } from '@/hooks/seo/useSeoSettings';
import { SiteTab } from './components/SiteTab';
import { PagesTab } from './components/PagesTab';
import { ImagesTab } from './components/ImagesTab';
import { AdvancedTab } from './components/AdvancedTab';

function Page() {
  React.useEffect(()=>{
    const m = document.createElement('meta');
    m.name = 'robots'; m.content = 'noindex,nofollow';
    document.head.appendChild(m);
    return ()=>{ m.remove(); };
  },[]);
  const { data, isLoading } = useSeoBundle('');
  const save = useSaveSeo();
  const ai = useAISuggest();
  const [tab, setTab] = React.useState<'site'|'pages'|'images'|'advanced'>(() => {
    const stored = typeof window !== 'undefined' ? localStorage.getItem('seoMainTab') : null;
    return (stored === 'site' || stored === 'pages' || stored === 'images' || stored === 'advanced') ? stored : 'site';
  });
  const [imagesDirty, setImagesDirty] = React.useState(false);
  const [pagesDirty, setPagesDirty] = React.useState(false);
  const [siteDirty, setSiteDirty] = React.useState(false);

  const handleTabChange = (newTab: 'site'|'pages'|'images'|'advanced') => {
    if (tab === 'site' && siteDirty) {
      if (!window.confirm('You have unsaved changes on the Site tab. Do you want to leave without saving?')) {
        return;
      }
    }
    if (tab === 'images' && imagesDirty) {
      if (!window.confirm('You have unsaved changes on the Images tab. Do you want to leave without saving?')) {
        return;
      }
    }
    if (tab === 'pages' && pagesDirty) {
      if (!window.confirm('You have unsaved changes on the Pages tab. Do you want to leave without saving?')) {
        return;
      }
    }
    setTab(newTab);
    localStorage.setItem('seoMainTab', newTab);
  };

  if (isLoading) return <div className="container mx-auto p-4">Loading...</div>;
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">SEO Maintenance</h1>
      <div className="flex gap-2 border-b mb-4">
        {(['site','pages','images','advanced'] as const).map(t=>(
          <button key={t} className={`px-4 py-2 ${tab===t?'border-b-2 border-primary font-medium':''}`} onClick={()=>handleTabChange(t)}>{t.toUpperCase()}</button>
        ))}
      </div>
      {tab === 'site' && <SiteTab data={data} save={save.mutate} ai={ai} pin="" onDirtyChange={setSiteDirty} />}
      {tab === 'pages' && <PagesTab data={data} save={save.mutate} ai={ai} onDirtyChange={setPagesDirty} />}
      {tab === 'images' && <ImagesTab data={data} onDirtyChange={setImagesDirty} />}
      {tab === 'advanced' && <AdvancedTab data={data} />}
    </div>
  );
}

export default withAdminGate(Page);
